export default __webpack_public_path__ + "static/media/carousel6.f8357106.png";